import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import InsightFiltersViewModel from "../../../ViewModels/InsightFiltersViewModel";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

interface IAutoCompleteFilterDialogProps {
    open: boolean
    setOpen: (value: boolean) => void
    filters: InsightFiltersViewModel
    setFilters: React.Dispatch<React.SetStateAction<InsightFiltersViewModel>>
    name: string
    label: string
    options: string[]
}

export default function AutoCompleteFilterDialog(
    { open, setOpen, filters, setFilters, name, label, options }: IAutoCompleteFilterDialogProps) {

    useEffect(() => {
        setValue(filters[name])
    }, [filters[name]])

    const [value, setValue] = useState<string>(filters[name])

    const confirm = () => {
        setFilters(prevState => ({
            ...prevState,
            [name]: value
        }));

        setOpen(false);
    }

    const onValueChange = (_event: any, newValue: string | null) => {
        setValue(newValue || '');
    }

    return (
        <>
            <Dialog open={open} fullWidth maxWidth='sm'>
                <DialogTitle>{`${label} Filter`}</DialogTitle>
                <Grid container justifyContent='center'>
                    <Grid size={8}>
                        <InputLabel>{label}</InputLabel>
                        <Autocomplete
                            fullWidth
                            options={options}
                            value={value}
                            onChange={onValueChange}
                            getOptionLabel={(option) => option}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth />
                            )}
                        />
                    </Grid>
                </Grid>
                <DialogContent>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>
                        Cancel
                    </Button>
                    <Button onClick={confirm}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

//<auto
//    name="preset"
//    onChange={onValueChange}
//    value={value}
//    fullWidth
//    endAdornment={value &&
//        <IconButton onClick={() => clearValue()} sx={{ marginRight: 2 }}>
//            <ClearIcon />
//        </IconButton>}
//>
//    {
//        options.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)
//    }
//</auto>